<template>
  <div class="columns is-vcentered">
    <div class="column is-2 has-text-centered-mobile">
      <img v-lazy="event.imgUrl" />
    </div>
    <div class="column is-9">
      <h1 class="title">{{ event.eventname }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventHeader',
  props: {
    event: {
      type: Object,
      default: null
    }
  }
}
</script>
